import React, { useEffect, useState } from "react";
import api from "../api";
import { Donut, LineChart, BarChart } from "../components/Charts";

const K = ({ n, l, tone }) => (
  <div className={`kpi ${tone || ""}`}><div className="n">{n ?? 0}</div><div className="l">{l}</div></div>
);

export default function Dashboard() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/dashboard").then((r) => setD(r.data?.data)).catch((e) => setErr(e?.response?.data?.message || "Failed to load dashboard"));
  }, []);
  const k = d?.kpis || {};
  return (
    <div>
      <h1>Compliance Dashboard</h1>
      <p className="sub">Real-time DPDP compliance overview</p>
      {err && <div className="err">{err}</div>}

      <h3 style={{ margin: "8px 0" }}>Data Inventory</h3>
      <div className="kpis">
        <K n={k.repositories} l="Data Repositories" />
        <K n={k.applications} l="Applications" />
        <K n={k.databases} l="Databases" />
        <K n={k.categories} l="Data Categories" />
        <K n={k.highRiskRepos} l="High-Risk Repositories" tone="danger" />
        <K n={k.unencryptedRepos} l="Unencrypted Repositories" tone="warn" />
        <K n={k.reposNoOwner} l="Repositories w/o Owner" tone="warn" />
        <K n={k.piiPlaintext} l="PII Plaintext Findings" tone="danger" />
      </div>

      <h3 style={{ margin: "8px 0" }}>Consent & Rights</h3>
      <div className="kpis">
        <K n={k.consentsActive} l="Active Consents" tone="ok" />
        <K n={k.consentsWithdrawn} l="Withdrawn Consents" tone="warn" />
        <K n={k.consentsExpired} l="Expired Consents" tone="warn" />
        <K n={k.requestsOpen} l="Open Privacy Requests" />
        <K n={k.grievancesOpen} l="Open Grievances" tone="warn" />
      </div>

      <h3 style={{ margin: "8px 0" }}>Incidents & Vendors</h3>
      <div className="kpis">
        <K n={k.breachesOpen} l="Open Breaches" tone="danger" />
        <K n={k.vendors} l="Vendors" />
        <K n={k.vendorsHighRisk} l="High-Risk Vendors" tone="danger" />
      </div>

      {d && (
        <>
          <div style={{ marginTop: 16 }}>
            <LineChart
              title="Intake Trend — last 12 months"
              months={d.charts?.trend?.months || []}
              series={d.charts?.trend?.series || []}
            />
          </div>
          <div className="chartgrid">
            <Donut title="Consent Status Mix" data={d.charts?.consentMix || []} />
            <BarChart
              title="Repositories by Department"
              data={d.charts?.byDepartment || []}
              empty="No repositories registered yet"
            />
          </div>
        </>
      )}

      {d?.charts?.piiByHost?.length > 0 && (
        <div className="card" style={{ marginTop: 16 }}>
          <div className="toolbar"><b>Personal Data by Host (agent discovery)</b></div>
          <div className="tablewrap">
            <table>
              <thead><tr><th>Host</th><th>Findings</th><th>Personal Data</th><th>Plaintext</th></tr></thead>
              <tbody>
                {d.charts.piiByHost.map((r) => (
                  <tr key={r.host}>
                    <td>{r.host}</td>
                    <td><b>{r.findings}</b></td>
                    <td>{r.personal > 0 ? <span className="pill warn">{r.personal}</span> : 0}</td>
                    <td>{r.plaintext > 0 ? <span className="pill danger">{r.plaintext}</span> : 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

    </div>
  );
}
